export default __webpack_public_path__ + "static/media/studentshome.8d408878.jpg";